import { BaseService } from '@/modules/Core/services/BaseService'
import type { IKioscoCategoria } from '@/modules/Administracion/interfaces/IKioscoCategoria'

export class KioscoCategoriaService extends BaseService<IKioscoCategoria> {
  constructor() {
    super({ baseUrl: 'kiosco/categorias/' })
  }
}
